import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Radio,
  DatePicker,
  Select,
  Row,
  Col,
} from "antd";
import "antd/dist/antd.css";
import GetHost from "../lib/GetHost";
import pr from "../util/pr";
import axios from "axios";
import moment from "moment";
import locale from "antd/es/date-picker/locale/ko_KR";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";
import CenterSelect from "../lib/CenterSelect";
import LoginCheck from "../util/LoginCheck";
import DecodeData from "../util/DecodeData";

const { Option } = Select;
const { confirm } = Modal;
const { RangePicker } = DatePicker;
const token = localStorage.getItem("refresh_token"); // 토큰

const columns = [
  {
    dataIndex: "cname",
    key: "cname",
    title: "센터명",
    align: "center",
    width: 250,
  },
  {
    dataIndex: "gubun",
    key: "gubun",
    title: "구분",
    align: "center",
    width: 150,
    render: (text) => {
      const x = text === "M" ? "회원" : "강사";
      return <div>{x}</div>;
    },
  },
  {
    dataIndex: "mb_name",
    key: "mb_name",
    title: "이름",
    align: "center",
    width: 150,
  },
  {
    dataIndex: "mb_phone",
    key: "mb_phone",
    title: "연락처",
    align: "center",
  },
];

const TableStyle = styled(Table)`
  tbody tr:hover {
    cursor: pointer;
  }
`;

let formData = {
  cid: "",
  gubun: "",
  mb_name: "",
  mb_phone: "",
};

function PtMemberAdd(props) {
  const { seq, visible, onHideModal, onReload, onFindMember } = props;
  const [form] = Form.useForm();
  const [rows, setRows] = useState([]);

  
  // 로그인
  const data = useSelector((state) => state.data);
  const dispatch = useDispatch();
  const getLogin = async () => {
    let result = await LoginCheck(data.url);
    if (result === "Y") {
      const decodeResult = await DecodeData(data.url);
      dispatch({ type: "SET", name: "CID", value: decodeResult.cid });
      dispatch({ type: "SET", name: "LEVEL", value: decodeResult.level });
    }
    if (data.cid !== "root") {
      formData.cid = data.cid;
    }
  };
  useEffect(() => {
    if (data.url !== "") {
      getLogin();
    }
  }, [data.url]);

  useEffect(() => {
    if (data.url !== "") {
      getLogin();
    }
  }, [data.url]);

  const handleCancel = () => {
    onHideModal();
  };

  // loadData
  const loadData = async () => {};

  useEffect(() => {
    loadData();
  }, [seq]);

  const onConfirm = () => {
    onHideModal();
  };

  const onFinish = async (value) => {
    let result = axios.post(GetHost() + "/gympass_admin/pt_coupon_update", {
      token: token,
      seq: value.seq,
      enroll_sdate: moment(value.enroll_date[0]).format("YYYY-MM-DD"),
      enroll_edate: moment(value.enroll_date[1]).format("YYYY-MM-DD"),
      use_count: value.use_count,
      total_count: value.total_count,
      state: value.state,
      pt_type: value.pt_type,
    });

    onHideModal();
    onReload();
  };

  const onDelete = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: "삭제하시겠습니까?",
      async onOk() {
        let result = await axios.post(
          GetHost() + "/gympass_admin/pt_coupon_delete",
          {
            seq: seq,
            token: token,
          }
        );
        onReload();
      },
      onCancel() {},
    });
  };

  const onSearch = async () => {
    const result = await axios.post(
      GetHost() + "/gympass_admin/search_member",
      {
        cid: formData.cid,
        gubun: formData.gubun,
        mb_phone: formData.mb_phone,
        mb_name: formData.mb_name,
      }
    );
    setRows(result.data);
  };

  const onCenterChange = (value) => {
    formData.cid = value;
  };

  const onRow = (record, rowIndex) => {
    return {
      onClick: (event) => {
        onFindMember({ mb_name: record.mb_name, mcd: record.mcd }); // 부모함수
        onHideModal();
        // record.mcd record.mb_name
        // console.log(record, rowIndex, event);
        // onShowEditModal();
      },
    };
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Modal
        width={800}
        onCancel={handleCancel}
        title="회원찾기"
        visible={visible}
        footer={[]}
      >
        <Row>
          {data.cid === "root" && (
            <Col span={12}>
              <Form.Item label="센터명" labelCol={{ span: 8 }}>
                <CenterSelect width="160" onCenterChange={onCenterChange} />
              </Form.Item>
            </Col>
          )}
          <Col span={12}>
            <Form.Item
              name="gubun"
              label="회원구분"
              labelCol={{ span: 8 }}
              initialValue=""
            >
              <Select
                style={{ width: 100 }}
                onChange={(value) => (formData.gubun = value)}
              >
                <Option value="M">회원</Option>
                <Option value="T">강사</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item name="mb_phone" label="연락처" labelCol={{ span: 8 }}>
              <Input
                style={{ width: 140 }}
                onChange={(event) => (formData.mb_phone = event.target.value)}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="고객명">
              <Form.Item name="mb_name" noStyle value={data.use_count}>
                <Input
                  style={{ width: 100 }}
                  autoComplete="off"
                  onChange={(event) => (formData.mb_name = event.target.value)}
                />
              </Form.Item>
              <Form.Item name="total_count" noStyle>
                <Button
                  type="primary"
                  onClick={onSearch}
                  style={{ marginLeft: 5 }}
                >
                  찾기
                </Button>
              </Form.Item>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <TableStyle
              rowKey="seq"
              columns={columns}
              dataSource={rows}
              bordered
              pagination={{
                pageSizeOptions: [],
              }}
              onRow={onRow}
            />
          </Col>
        </Row>
      </Modal>
    </Form>
  );
}

export default PtMemberAdd;
